import { render, staticRenderFns } from "./RunnitTemplate.vue?vue&type=template&id=35cf9f2d&scoped=true"
import script from "./RunnitTemplate.vue?vue&type=script&lang=ts"
export * from "./RunnitTemplate.vue?vue&type=script&lang=ts"
import style0 from "./RunnitTemplate.vue?vue&type=style&index=0&id=35cf9f2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf9f2d",
  null
  
)

export default component.exports